import "./style.scss";

import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconCheckCircleFill from "@amzn/stencil-react-icons/icons/icon-check-circle-fill";
import { IconSize } from "@amzn/stencil-react-icons/icons/interfaces";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

export const MessageConfirmation: FC = () => {
  return (
    <Col>
      <Row>
        <View display="flex" justifyContent="center" width="100%" height="100%">
          <img src="/img/hardwareSupportCheckList.svg" alt="" style={{ width: 178, height: 145 }} />
        </View>
      </Row>
      <Row padding="S500" gridGap="S300">
        <IconCheckCircleFill color="green70" size={IconSize.Large} title="Success" />
        <Text fontSize="T300" fontWeight="bold">
          {getString("supportMessageConfirmation.confirmationTitle")}
        </Text>
      </Row>
      <Row padding={{ left: "S500", right: "S500" }}>
        <Text>{getString("supportMessageConfirmation.confirmationText")}</Text>
      </Row>
    </Col>
  );
};
